import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetSelfServiceSubscriptionsFrequencyParams } from '../../../ts/ServerApi/types/actionParams';

export class SetSelfServiceSubscriptionsFrequencyRequest extends Request<ISetSelfServiceSubscriptionsFrequencyParams, IEmptyResult> {
    constructor(params: ISetSelfServiceSubscriptionsFrequencyParams) {
        super('setSubscriptionsSelfServiceSchedule', params);
    }
}
